import { render, staticRenderFns } from "./ExpiresCard.vue?vue&type=template&id=561a5833&"
import script from "./ExpiresCard.vue?vue&type=script&lang=js&"
export * from "./ExpiresCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports